import React from 'react';
import GameBoard from '../board/GameBoard';

function GameBoardScreen() {
  return (
    <div className="game-board-screen">
      <GameBoard />
    </div>
  );
}

export default GameBoardScreen;
